import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CountdownTimer = ({ endTime }) => {
  const calculateTimeLeft = () => {
    if (!endTime) return null;

    const difference = new Date(endTime).getTime() - new Date().getTime();
    if (isNaN(difference) || difference <= 0) {
      return null;
    }
    const timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [endTime]);

  if (!timeLeft) {
    return <div className='flex justify-center'><p className="text-red-500 w-max cursor-pointer hover:text-red-600 mt-20 text-[24px] font-semibold transition-colors duration-100 ease-linear">Your Trial has ended!</p>;</div>
  }

  return (
    <div className="flex flex-col items-center text-center">
      <p className="text-gray-700 text-[24px] mt-20 font-semibold mb-2">Your Trial Ends In:</p>
      
      <div className="flex gap-4 text-3xl font-bold text-blue-600">
        {['days', 'hours', 'minutes', 'seconds'].map((unit) => (
          <div key={unit} className="flex flex-col items-center">
            <AnimatePresence mode="wait">
              <motion.span
                key={timeLeft[unit]}
                initial={{ y: -10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 10, opacity: 0 }}
                transition={{ duration: 0.3 }}
              >
                {timeLeft[unit]}
              </motion.span>
            </AnimatePresence>
            <span className="text-xs text-gray-500">{unit.charAt(0).toUpperCase() + unit.slice(1)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CountdownTimer;
